export default __webpack_public_path__ + "static/media/romero.b8d66fa8.jpg";